import type { CaseStatus } from '@vrzl/database';

export type EventFilters = {
  status?: CaseStatus;
  page?: number;
  limit?: number;
  search?: string;
  assignee?: string;
  statusOrder?: 'expired-first' | 'open-first';
};

export const eventKeys = {
  all: ['events'] as const,
  lists: () => [...eventKeys.all, 'list'] as const,
  list: (filters?: EventFilters) => [...eventKeys.lists(), { filters }] as const,
  details: () => [...eventKeys.all, 'detail'] as const,
  detail: (id: string) => [...eventKeys.details(), id] as const,
  assignees: () => [...eventKeys.all, 'assignees'] as const,
} as const;
